var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/core/parts/part.ts
var Part = class {
  constructor(element) {
    this.element = element;
  }
};
var part_default = Part;

// src/core/parts/script.ts
var Script = class extends part_default {
  constructor(element) {
    super(element);
  }
  on() {
    const data = this.element.dataset;
    const element = document.createElement(this.element.tagName);
    const parent = this.element.parentElement;
    for (const attribute of this.element.attributes) {
      element.setAttribute(attribute.name, attribute.value);
    }
    element.innerText = this.element.innerText;
    if ("type" in data && data.type) {
      element.setAttribute("type", data.type);
    }
    if ("src" in data && data.src) {
      element.setAttribute("src", data.src);
    }
    if (parent) {
      parent.insertBefore(element, this.element);
      parent.removeChild(this.element);
    }
  }
  off() {
    var _a, _b, _c, _d;
    const attributes = this.element.attributes;
    if ((_a = attributes.getNamedItem("type")) == null ? void 0 : _a.value) {
      this.element.setAttribute(
        "data-type",
        (_b = attributes.getNamedItem("type")) == null ? void 0 : _b.value
      );
      this.element.setAttribute("type", "text/plain");
    }
    if ((_c = attributes.getNamedItem("src")) == null ? void 0 : _c.value) {
      this.element.setAttribute(
        "data-src",
        (_d = attributes.getNamedItem("src")) == null ? void 0 : _d.value
      );
      this.element.removeAttribute("src");
    }
  }
};
var script_default = Script;

// src/core/parts/element.ts
var Element = class extends part_default {
  constructor(element, options) {
    super(element);
    this.options = options;
  }
  on() {
    if (this.element.classList.contains("gcmp-none")) {
      this.element.classList.remove("gcmp-none");
    }
  }
  off() {
    var _a;
    if (((_a = this.options) == null ? void 0 : _a.mode) === "remove") {
      this.element.remove();
    } else {
      this.element.classList.add("gcmp-none");
    }
  }
};
var element_default = Element;

// src/core/parts/iframe.ts
var Iframe = class extends part_default {
  constructor(element, options) {
    super(element);
    this.options = options != null ? options : void 0;
  }
  on() {
  }
  off() {
    var _a, _b, _c;
    const container = document.createElement("div");
    const placeholder = document.createElement("div");
    const caption = document.createElement("div");
    const script = document.createElement("script");
    script.setAttribute("type", "text/plain");
    script.innerText = btoa(this.element.outerHTML);
    container.setAttribute("data-embed", "");
    container.classList.add("gcmp-embed");
    placeholder.classList.add("gcmp-embed-placeholder");
    caption.classList.add("gcmp-embed-caption");
    caption.innerText = (_b = (_a = this.options) == null ? void 0 : _a.captionsTitle) != null ? _b : "";
    placeholder.appendChild(caption);
    container.appendChild(placeholder);
    container.appendChild(script);
    (_c = this.element.parentNode) == null ? void 0 : _c.replaceChild(container, this.element);
  }
};
var iframe_default = Iframe;

// src/utils/placeholder.ts
var Placeholder = () => {
  return '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 400 225" viewBox="0 0 400 225"><path d="M0 112.5V225h400V0H0v112.5m295.6-52.2c1.6.6 3.1 1.9 3.8 3.4l.6 1.3v47.4c0 51.2.1 47.9-1.2 49.8-.3.5-1.1 1.2-1.8 1.7l-1.2.9-95.5.1c-93.3.1-95.6 0-96.5-.4-1.3-.6-2.6-1.8-3.3-3.1l-.6-1.1V64.7l.5-1c.8-1.7 2-2.8 3.6-3.4 1.5-.6 189.9-.6 191.6 0m-115.9 52.1c0 1.9 0 2.6.1 1.6v-3.4c0-.8-.1 0-.1 1.8m6.5 0c0 1.9 0 2.6.1 1.6v-3.4c0-.8-.1 0-.1 1.8m34 0c0 1.9 0 2.6.1 1.6v-3.4c0-.8-.1 0-.1 1.8" style="fill-rule:evenodd;clip-rule:evenodd;fill:#ccc"/><path d="M105.2 60.3c-2.1.4-3.4 1.3-4.3 2.9l-.6 1.1v96.4l.6.9c.7 1.2 1.4 1.8 2.7 2.4l1 .5 94.7.1c66.6 0 95 0 95.8-.2 1.3-.3 3.2-1.6 3.7-2.6.2-.4.4-.7.6-.8.1-.1.2-16.5.2-48.4V64.3l-.8-1.3c-.7-1-1.1-1.4-2.4-2l-1.5-.8h-94.3c-52 0-94.9 0-95.4.1m81.4 52.1.1 3.3h-7v-6.8l3.4.1 3.4.1.1 3.3m17.3 0 .1 3.3h-7.2v-6.8l3.5.1 3.5.1.1 3.3m16.8-.1v3.3l-3.5.1-3.5.1V109l3.5.1 3.5.1v3.1" style="fill-rule:evenodd;clip-rule:evenodd;fill:#848484"/><path d="M179.9 112.4v3.3h6.4v-6.6h-6.5v3.3m17.2 0v3.3l3.2-.1 3.2-.1.1-3.2.1-3.2H197v3.3m16.8 0v3.3h6.4v-6.6h-6.4v3.3" style="fill-rule:evenodd;clip-rule:evenodd;fill:#fcfcfc"/><path d="M104.7 60c-.1.1 42.7.2 95.2.2s95.2-.1 95-.2c-.5-.1-189.8-.2-190.2 0m-1.7.8c-.4.2-.8.6-.9.7-.1.2 0 .1.3-.1.2-.2.7-.5 1.1-.7.4-.2.6-.4.5-.4-.2 0-.7.2-1 .5m192.6-.4c.1.1.5.3.9.5.6.3.7.3.5.1-.2-.2-.6-.4-.9-.5-.4-.2-.6-.2-.5-.1M298 62c.4.5.9 1.1 1.1 1.4.2.2.1.1 0-.2-.2-.4-.7-1-1.1-1.3l-.7-.7.7.8m-197.8 2.1c-.1.3-.2.6-.1.7.1.1.2-.2.3-.6.2-.9.1-1-.2-.1m199.4.8c.2 1.2.2 93.8 0 95-.1.8-.1.8.1.5.4-.7.4-95.2 0-95.9-.3-.4-.3-.3-.1.4M99.8 112.4c0 26 0 36.6.1 23.6V88.7c0-12.9-.1-2.3-.1 23.7m81.6-3.3h3.3c.9 0 .2-.1-1.6-.1s-2.6.1-1.7.1m15.4.1c-.1.2-.1 1.7 0 3.4l.1 3.1.1-3.3v-3.3h6.6l.1 3.3.1 3.3v-6.6l-3.3-.1c-2.8-.1-3.6 0-3.7.2m16.9 0c-.1.2-.1 1.7 0 3.4l.1 3.1v-6.6h6.6l.1 3.3.1 3.3v-6.6l-3.3-.1c-2.7-.1-3.5 0-3.6.2m-113.6 51.3c.2.8.5 1 .4.3-.1-.3-.2-.6-.3-.7-.2-.1-.2.1-.1.4m198.8 1.2-.4.7.5-.5c.4-.5.6-.9.4-.9-.1-.1-.3.3-.5.7m-198.1.3c.2.5 1.2 1.4 1.9 1.8.2.1.1 0-.2-.3-.3-.3-.9-.8-1.2-1.2-.4-.5-.6-.6-.5-.3m195.1 2.2c-.4.2-.5.3-.3.3s.5-.1.8-.3c.5-.4.4-.4-.5 0m-192 .2c.4.2.8.3 1 .3.2 0 0-.1-.5-.3-1-.4-1.4-.4-.5 0" style="fill-rule:evenodd;clip-rule:evenodd;fill:#acacac"/><path d="M296.5 61c.8.5 1.2.7.7.2-.3-.3-.7-.5-.8-.5-.2.1-.1.2.1.3m-196.4 3.7c-.2.5-.2 95.3 0 95.4.1.1.2-21.5.2-47.8V64.4s-.1.1-.2.3m199.6 47.7c0 25.6 0 36.1.1 23.2V89c-.1-12.7-.1-2.2-.1 23.4m-113.3 0 .1 3.4.1-3.2c0-1.8 0-3.3-.1-3.4-.2-.2-.2 1.3-.1 3.2m17.3 0 .1 3.4.1-3.2c0-1.8 0-3.3-.1-3.4-.1-.2-.1 1.3-.1 3.2m16.9-.1.1 3.3.1-3.1c0-1.7 0-3.2-.1-3.3-.1-.2-.2 1.3-.1 3.1m-115.8 52.3c.2.1 43 .2 95 .2 52.1 0 94.8-.1 95-.2.2-.1-42.6-.2-95-.2s-95.2.1-95 .2" style="fill-rule:evenodd;clip-rule:evenodd;fill:#949494"/></svg>';
};
var placeholder_default = Placeholder;

// src/core/app.ts
var App = class {
  constructor(config) {
    this.waitForGfcTimeout = setTimeout(() => {
    });
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
    this.initialized = false;
    this.tcfVersion = (_a = config.tcfVersion) != null ? _a : 2.2;
    this.debug = (_b = config.debug) != null ? _b : false;
    this.waitForDom = (_c = config.waitForDom) != null ? _c : void 0;
    this.initWithGoogle = (_d = config.initWithGoogle) != null ? _d : true;
    this.root = (_e = config.root) != null ? _e : document;
    this.purposes = (_f = config.purposes) != null ? _f : null;
    this.embedOptions = (_g = config.embedOptions) != null ? _g : {
      defaultHeight: "240px",
      captionsTitle: "Please accept the terms for embedded content"
    };
    this.elementOptions = (_h = config.elementOptions) != null ? _h : {};
    this.waitForGfcInitTs = Date.now();
    this.waitForGfcTimeout = null;
    this.reloadAfterUserAction = (_i = config.reloadAfterUserAction) != null ? _i : false;
    this.onInit = (_j = config.onInit) != null ? _j : void 0;
    this.onUi = (_k = config.onUi) != null ? _k : void 0;
    this.onLoad = (_l = config.onLoad) != null ? _l : void 0;
    this.onAdStatus = (_m = config.onAdStatus) != null ? _m : void 0;
    this.tcfStatus = "";
    if (!this.initWithGoogle && this.waitForDom === void 0) {
      this.waitForDom = true;
    }
    if (this.debug) {
      console.info("gcmp init with config", config);
    }
    this.init();
  }
  init() {
    if (this.debug) {
      console.info("gcmp initializing");
    }
    if (!this.purposes) {
      console.error("No purposes configured");
    }
    if (this.initWithGoogle) {
      this.initGoogle();
    } else {
      if (this.onInit && typeof this.onInit === "function") {
        this.onInit(this);
      }
      if (this.onLoad && typeof this.onLoad === "function") {
        this.onLoad(this);
      }
      if (this.onUi && typeof this.onUi === "function") {
        this.onUi(this);
      }
    }
    this.initCss();
    this.initialized = true;
    if (this.debug) {
      console.info("gcmp initialized");
    }
  }
  refresh() {
    const data = this == null ? void 0 : this.tcfData;
    if (this.debug) {
      console.info("gcmp refresh");
    }
    if (data && "purpose" in data && data.purpose && typeof data.purpose === "object") {
      if ("consents" in data.purpose && data.purpose.consents && typeof data.purpose.consents === "object") {
        if (this.debug) {
          console.info("gcmp refresh consents", data.purpose.consents);
        }
        this.render(data.purpose.consents);
      }
    }
  }
  waitForGfc(callback) {
    const elapsedTime = Date.now() - this.waitForGfcInitTs;
    if (elapsedTime >= 3e3) {
      if (this.waitForGfcTimeout) {
        clearTimeout(this.waitForGfcTimeout);
      }
      this.waitForGfcTimeout = null;
      if (this.debug) {
        console.error("Google consent API not found (timed out)");
      }
      return;
    }
    if ("googlefc" in window && window.googlefc) {
      this.waitForGfcTimeout = null;
      callback();
    } else {
      this.waitForGfcTimeout = setTimeout(() => {
        this.waitForGfc(callback);
      }, 10);
    }
  }
  initGoogle() {
    const observer = new MutationObserver((mutations, obs) => {
      const dialog = document.getElementsByClassName("fc-choice-dialog");
      if (dialog.length) {
        if (this.onUi && typeof this.onUi === "function") {
          this.onUi(this);
        }
        obs.disconnect();
        return;
      }
    });
    observer.observe(document, {
      childList: true,
      subtree: true
    });
    this.waitForGfc(() => {
      window.googlefc.callbackQueue.push({
        CONSENT_DATA_READY: () => {
          window.googlefc.callbackQueue.push({
            AD_BLOCK_DATA_READY: () => {
              if (this.debug) {
                console.info("gcmp ad block data ready callback");
              }
              if (this.onAdStatus) {
                this.onAdStatus(window.googlefc.getAllowAdsStatus());
              }
            }
          });
          if (this.debug) {
            console.info("gcmp consent data ready callback");
          }
          if ("__tcfapi" in window && window.__tcfapi) {
            window.__tcfapi(
              "addEventListener",
              this.tcfVersion,
              (data) => {
                this.tcfData = data;
                if (this.debug) {
                  console.info("gcmp tcfapi ready callback", data);
                }
                this.tcfStatus = data == null ? void 0 : data.eventStatus;
                if (this.tcfStatus === "tcloaded" && this.onLoad && typeof this.onLoad === "function") {
                  this.onLoad(this);
                }
                if (this.onInit && typeof this.onInit === "function") {
                  this.onInit(this);
                }
                if (this.reloadAfterUserAction && (data == null ? void 0 : data.eventStatus) === "useractioncomplete") {
                  window.location.reload();
                }
                if ("purpose" in data && data.purpose && typeof data.purpose === "object") {
                  if ("consents" in data.purpose && data.purpose.consents && typeof data.purpose.consents === "object") {
                    if (this.debug) {
                      console.info(
                        "gcmp tcfapi render consent",
                        data.purpose.consents
                      );
                    }
                    this.render(data.purpose.consents);
                  }
                }
              }
            );
          }
        }
      });
    });
  }
  initCss() {
    var _a, _b, _c;
    const head = this.root.getElementsByTagName("head");
    const placeholder = ((_a = this.embedOptions) == null ? void 0 : _a.svgBackground) ? (_b = this.embedOptions) == null ? void 0 : _b.svgBackground : placeholder_default();
    if (head) {
      const css = `
        .gcmp-none {
          display: none;
          pointer-events: none;
          -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none;
          user-select: none;
        }
        .gcmp-embed {
          position: relative;
          display: block;
          overflow: hidden;
          max-width: 100%;
          min-width: 240px;
          min-height: ${((_c = this.embedOptions) == null ? void 0 : _c.defaultHeight) || "inherit"};
          height: inherit;
          padding-bottom: inherit;
          background-image: url("data:image/svg+xml;base64, ${btoa(
        placeholder
      )}");
          background-color: transparent;
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
        }
        .gcmp-embed-placeholder {
          top: 50%;
          left: 0;
          position: absolute;
          width: 100%;
          text-align: center;
          transform: translateY(-50%);
          background: hsla(0, 0%, 0%, 0.8);
          color: #fff;
          font-size: 13px;
          padding: 10px;
        }
        .gcmp-embed-caption {
          overflow-wrap: break-word;
          word-wrap: break-word;
          -ms-word-break: break-all;
          word-break: break-all;
          word-break: break-word;
          -ms-hyphens: auto;
          -moz-hyphens: auto;
          -webkit-hyphens: auto;
          hyphens: auto;
        }
      `;
      const style = document.createElement("style");
      style.setAttribute("type", "text/css");
      style.appendChild(document.createTextNode(css));
      head[0].appendChild(style);
    }
  }
  revoke() {
    if (this.initialized) {
      window.googlefc.callbackQueue.push({
        CONSENT_DATA_READY: () => {
          window.googlefc.showRevocationMessage();
        }
      });
    } else {
      if (this.debug) {
        console.error("gcmp not initialized");
      }
    }
  }
  render(consents) {
    const _render = () => {
      var _a;
      const purposes = {};
      (_a = this.purposes) == null ? void 0 : _a.forEach((p) => {
        if (!(p.purpose in purposes)) {
          purposes[p.purpose] = [];
        }
        purposes[p.purpose].push(p);
      });
      Object.keys(consents).forEach((k) => {
        const key = k;
        const consent = consents[key];
        if (key in purposes) {
          if (this.debug) {
            console.info(
              `gcmp rendering purpose: ${key} with consent: ${consent}`
            );
          }
          purposes[key].forEach((p) => {
            if (this.debug) {
              console.info(`gcmp rendering object`, p);
            }
            if (p.onRender && typeof p.onRender === "function") {
              const result = p.onRender(
                consent,
                this.root.querySelectorAll(p.selectors),
                this
              );
              if (result === false) {
                return;
              }
            }
            this.renderOnOff(p, consent);
            this.renderCookies(p, consent);
            this.renderStorage(p, consent);
          });
        }
      });
    };
    if (this.waitForDom) {
      document.addEventListener(
        "DOMContentLoaded",
        function() {
          _render();
        },
        false
      );
    } else {
      _render();
    }
  }
  renderOnOff(purpose, on) {
    var _a, _b, _c;
    let elementOptions = (_a = this.elementOptions) != null ? _a : {};
    const tags = (_b = purpose.tags) != null ? _b : [];
    const mode = (_c = purpose.mode) != null ? _c : void 0;
    try {
      const nodes = this.root.querySelectorAll(
        purpose.selectors
      );
      if (this.debug) {
        console.info(
          `gcmp found the following nodes to render for purpose: ${purpose.purpose} (${purpose.selectors})`,
          nodes
        );
      }
      if (nodes.length) {
        nodes.forEach((element) => {
          const name = element.nodeName.toLowerCase();
          if (this.debug) {
            console.info(
              `gcmp rendering: ${name} for purpose: ${purpose.purpose} (${purpose.selectors}) to: ${on}`
            );
          }
          if (tags.length && !tags.includes(name)) {
            if (this.debug) {
              console.warn(
                `gcmp skipping: ${name} for purpose: ${purpose.purpose} (${purpose.selectors}) since its not in provided tag list`
              );
            }
            return null;
          }
          switch (name) {
            case "script":
              new script_default(element)[on ? "on" : "off"]();
              break;
            case "iframe":
              new iframe_default(element, this.embedOptions)[on ? "on" : "off"]();
              break;
            default:
              if (this.debug) {
                console.warn(
                  `gcmp tag: ${name} is not defined and falls back to default element`
                );
              }
              if (mode) {
                elementOptions = __spreadValues(__spreadValues({}, elementOptions), { mode });
              }
              new element_default(element, elementOptions)[on ? "on" : "off"]();
          }
        });
      }
    } catch (e) {
      if (this.debug) {
        console.warn(`gcmp purpose: ${purpose.purpose} has illegal selectors`);
      }
    }
  }
  renderCookies(purpose, on) {
    var _a;
    if (!on && "cookies" in purpose && ((_a = purpose.cookies) == null ? void 0 : _a.length)) {
      const cookies = document.cookie.split(";");
      if (cookies.length > 0) {
        cookies.forEach((cookie) => {
          var _a2;
          const name = cookie.trim().split("=")[0];
          (_a2 = purpose.cookies) == null ? void 0 : _a2.forEach((rule) => {
            if (rule.test(name)) {
              if (this.debug) {
                console.info(
                  `gcmp remove cookies: ${name} for purpose: ${purpose.purpose}`
                );
              }
              document.cookie = name + "=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            }
          });
        });
      }
    }
  }
  renderStorage(purpose, on) {
    var _a, _b, _c, _d;
    if (!on) {
      if ("localStorage" in purpose && ((_a = purpose.localStorage) == null ? void 0 : _a.length) && window.localStorage) {
        const items = __spreadValues({}, window.localStorage);
        for (const [key, value] of Object.entries(items)) {
          (_b = purpose.localStorage) == null ? void 0 : _b.forEach((rule) => {
            if (rule.test(key)) {
              if (this.debug) {
                console.info(
                  `gcmp remove from local storage: ${key}: ${value} for purpose: ${purpose.purpose}`
                );
              }
              window.localStorage.removeItem(key);
            }
          });
        }
      }
      if ("sessionStorage" in purpose && ((_c = purpose.sessionStorage) == null ? void 0 : _c.length) && window.sessionStorage) {
        const items = __spreadValues({}, window.sessionStorage);
        for (const [key, value] of Object.entries(items)) {
          (_d = purpose.sessionStorage) == null ? void 0 : _d.forEach((rule) => {
            if (rule.test(key)) {
              if (this.debug) {
                console.info(
                  `gcmp remove from session storage: ${key}: ${value} for purpose: ${purpose.purpose}`
                );
              }
              window.sessionStorage.removeItem(key);
            }
          });
        }
      }
    }
  }
};
var app_default = App;

// src/app/component.tsx
var GcmpComponent = (props) => {
  const { config } = props;
  new app_default(config);
  return null;
};

// src/app/provider.tsx
import * as React from "react";
var instance = null;
var GcmpContext = React.createContext(void 0);
var GcmpProvider = (props) => {
  const { children, config } = props;
  React.useEffect(() => {
    if (typeof window !== "undefined" && !instance) {
      instance = new app_default(config);
    }
  }, []);
  return /* @__PURE__ */ React.createElement(GcmpContext.Provider, { value: { config } }, children);
};
var useGcmpProvider = () => {
  const context = React.useContext(GcmpContext);
  if (!context) {
    throw new Error("useGcmpProvider must be used within a GcmpProvider");
  }
  return context;
};

// src/index.ts
var app = void 0;
var init = (config) => {
  app = new app_default(config);
  return app;
};
var refresh = () => {
  app == null ? void 0 : app.refresh();
};
export {
  GcmpComponent,
  GcmpProvider,
  init,
  refresh,
  useGcmpProvider
};
//# sourceMappingURL=index.mjs.map